import { Container, Item } from 'Components/Grid';
import * as React from 'react';

const DosageFormat = ({ header, content }: IDosageFormatProps): React.JSX.Element => (
  <Container alignItems="center" style={{ paddingBottom: '1.5rem' }}>
    <Item xs={2}>{header}</Item>
    <Item xs={10}>{content}</Item>
  </Container>
);

interface IDosageFormatProps {
  header?: React.JSX.Element | string;
  content?: React.JSX.Element;
}

export default DosageFormat;
